import { render } from "./CalendarBodyDates.vue?vue&type=template&id=bc83455c&scoped=true"
import script from "./CalendarBodyDates.vue?vue&type=script&lang=ts"
export * from "./CalendarBodyDates.vue?vue&type=script&lang=ts"

import "./CalendarBodyDates.vue?vue&type=style&index=0&id=bc83455c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bc83455c"

export default script